import guestlistDetails from '../sub/guestlist-details';

export default [
    {
        key: 'events.guestlists.main',
        type: 'route',
        route: 'app.guestlists.index',
        right: 'guestlists::list',
        showParentTabs: true
    },
    {
        key: 'events.guestlists.details.main',
        type: 'event-selector',
        paramName: 'gid',
        showInNavigation: false,
        children: guestlistDetails
    },
    {
        key: 'events.masterlist.main',
        type: 'placeholder',
        children: [
            {
                key: 'events.masterlist.list',
                type: 'route',
                route: 'app.guestlists.masterlist',
                right: 'rsvps::list'
            },
            {
                key: 'events.masterlist.changelog',
                type: 'route',
                route: 'app.guestlists.master-changelog',
                right: 'rsvps::changelog'
            }
        ]
    },
    {
        key: 'events.exports',
        type: 'route',
        route: 'app.exports.rsvps',
        right: 'exports::rsvps'
    },
];



// WEBPACK FOOTER //
// ./src/app/modules/navigation/resources/second-level/events.js